module.exports = __webpack_public_path__ + "img/Sent.524e0c42.svg";